import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import '@/shared/lib/gsap'; // Import GSAP early to register plugins before any component uses them
import App from '@/app/App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);